<template>
    <div>
        <div class="row">
            <div class="col-lg-7">
                <p>Manage Member Invoice Payments:</p>
            </div>
            <div class="col-lg-5">
                <div class="switch">
                    <label :class="{ 'pull-right': isEdit }">
                        No
                        <template v-if="vm.controlsInvoice">
                            <input type="checkbox" v-model="vm.controlsInvoice" checked=""
                                @change="saveControlsInvoice($event)">
                        </template>
                        <template v-else>
                            <input type="checkbox" v-model="vm.controlsInvoice" @change="saveControlsInvoice($event)">
                        </template>
                        <span class="lever"></span> Yes
                    </label>
                </div>
            </div>

            <div>
                <div class="col-lg-12">
                    <p class="text-primary">
                        <small>
                            <em>
                                Create and Collect one time payments.
                            </em>
                        </small>
                    </p>
                </div>
            </div>
        </div>
        <div class="row" v-if="vm.controlsInvoice">
            <div class="col-lg-7">
                <p>Manage Invoice Line Items:</p>
            </div>
            <div class="col-lg-5">
                <div class="switch">
                    <label :class="{ 'pull-right': isEdit }">
                        No
                        <template v-if="vm.controlsLineItems">
                            <input type="checkbox" v-model="vm.controlsLineItems" checked=""
                                @change="saveControlsLineItems($event)">
                        </template>
                        <template v-else>
                            <input type="checkbox" v-model="vm.controlsLineItems"
                                @change="saveControlsLineItems($event)">
                        </template>
                        <span class="lever"></span> Yes
                    </label>
                </div>
            </div>
            <div>
                <div class="col-lg-12">
                    <p class="text-primary">
                        <small>
                            <em>
                                Create or delete invoice line items.
                            </em>
                        </small>
                    </p>
                </div>
            </div>
        </div>
        <hr>
    </div>
</template>

<script>
import { api } from "../../../global/framework/api.js";
export default {
    name: "Invoice",
    props: {
        value: { type: Object, required: true },
        isEdit: { type: Boolean, required: true }
    },
    data() {
        return {
            vm: { ...this.value }
        };
    },
    methods: {
        saveControlsInvoice() {
            if (!this.vm.controlsInvoice) { this.vm.controlsLineItems = false }

            if (this.isEdit) {
                api.post('ProviderEntity', 'SaveControlsInvoiceSetting', {
                    providerEntityId: this.vm.providerEntityId,
                    controlsInvoice: this.vm.controlsInvoice,
                    controlsLineItems: this.vm.controlsLineItems
                });
            }
            else {
                this.value.controlsInvoice = this.vm.controlsInvoice;
                this.value.controlsLineItems = this.vm.controlsLineItems;
            }
        },
        saveControlsLineItems() {
            if (this.isEdit) {
                api.post('ProviderEntity', 'SaveControlsLineItemsSetting', {
                    providerEntityId: this.vm.providerEntityId,
                    controlsLineItems: this.vm.controlsLineItems
                });
            }
            else {
                this.value.controlsLineItems = this.vm.controlsLineItems;
            }
        }
    }
}
</script>
